










import { defineComponent, onMounted, ref, useFetch, useContext } from '@nuxtjs/composition-api'
import HotTopicList from '~/components/solepro/HotTopics/HotTopicList.vue';
import OtherHotTopics from '~/components/solepro/HotTopics/OtherHotTopics.vue';
import LandingHero from '~/components/solepro/LandingHero.vue';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useApi, useCategory } from '~/composables';
import { GET_HOT_TOPIC_DETAIL, GET_HOT_TOPICS } from '~/modules/catalog/category/queries/solepro/gotTopics.gql';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { usePageResolver } from '~/stores/page';
import { extendProductsForBox } from '~/utils/solepro/products';
import { hotTopicPageView } from '~/helpers/trackings/24orepro/pages';
import ClientOnly from 'vue-client-only';

export default defineComponent({
    components: {
        LandingHero,
        HotTopicList,
        OtherHotTopics,
        ClientOnly
    },
    setup() {
        const { $config } = useContext();
        const { query } = useApi();
        const { resolveUrl } = usePageResolver();
        const { loadCategoryMeta } = useCategory();
        const datas = ref();
        const categoryMeta = ref(null);
        const activeCategoryName = ref('');
        const hotTopic = ref();
        useFetch(async () => {
            const routeData = await resolveUrl();
            const allCategories = ref([]);
            const categoryStore = useCategoryStore()
            categoryMeta.value = await loadCategoryMeta({ category_uid: routeData.uid });
            const categoryResponse = await query(GET_HOT_TOPICS, { hotTopicsUid: routeData.uid });
            hotTopic.value = categoryResponse.data['categories'].items[0]
            const { data } = await query(GET_HOT_TOPIC_DETAIL, { filter: { category_uid: { eq: routeData.uid } } });
            categoryStore.load()
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            const items = extendProductsForBox(allCategories.value, data['products'].items).map(el => {
                return {
                    ...el,
                    box_description: el.hot_topics_description ?? el.box_description
                }
            });
            activeCategoryName.value = hotTopic.value.name;
            datas.value = {
                hotTopicsUid: allCategories.value.find(el=>el.name.toLowerCase()=='temi caldi')?.uid,
                title: hotTopic.value.name,
                subtitle: hotTopic.value.description,
               
                imageSrc: hotTopic.value.image,
                items
            }

        })
        
        onMounted(()=>{
             try{hotTopicPageView(hotTopic.value.name)}
             catch(e){}

        })
        return {
            datas,
            hotTopic,
            categoryMeta,
            activeCategoryName,
            config: $config
        }
    },
    head() {
    const ProductListItems = ((this as any).datas.items as any).map((product, index) => {
      return {
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "url": `${this.config.soleproDomain}/24orepro/${product.url_key}${product.url_suffix}`,
        }
      }
    })
    return {
      ...getMetaInfo({...(this.categoryMeta as any), title: this.activeCategoryName}, false, 'category'),
      script: [
        {
          hid: 'ld-product-list',
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": ProductListItems
          }
        }
      ]
    }
  }
})
